import styled, { css } from "styled-components";

export const FooterStyled = styled.footer.withConfig({
  shouldForwardProp: (prop) => !["relative"].includes(prop),
})`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
  border-top: 2px solid #9c9c9c;
  gap: 20px;
  ${({ relative }) =>
    relative
      ? css`
          position: absolute;
          bottom: 0;
          z-index: 2;
        `
      : css`
          position: relative;
        `}
  span {
    color: #b0b0b0;
  }
  ul {
    display: flex;
    gap: 8px;
    list-style: none;
    li {
      color: #9c9c9c;
      cursor: pointer;
      a {
        text-decoration: none;
        text-decoration: none !important;
        color: #9c9c9c;
      }
      a:hover {
        color: white;
      }
    }
  }

  @media (max-width: 650px) {
    padding: 15px 9px;
    padding-bottom: 100px;
    align-items: flex-start;
    span {
      font-size: 14px;
    }
  }
`;
